<button
  (click)="onButtonClick()"
  [class.task-item-variable-bg]="!newTask"
  class="date-time-button"
  [class.selected-row-button]="isSelected"
>
  <oph-icon [name]="iconName" [size]="iconSize"></oph-icon>
  @if (type === 'date') {
    {{
      dateValue
        ? (dateValue | convertUtcToTimezone: dateFormatMoment | uppercase)
        : (today | date: dateFormat | uppercase)
    }}
  } @else {
    {{ dateValue | convertUtcToTimezone: dateFormat | uppercase }}
  }
</button>
